export default __webpack_public_path__ + "static/8_31-759d10f6d76836f0026e24e5a4798f4b.png";